"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('underscore'),
  last = _require.last;
var MultilanguagePicker = /*#__PURE__*/function () {
  MultilanguagePicker.$inject = ["EventEmitter"];
  /* @ngInject */
  function MultilanguagePicker(EventEmitter) {
    _classCallCheck(this, MultilanguagePicker);
    this.EventEmitter = EventEmitter;
  }
  return _createClass(MultilanguagePicker, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.model.length) {
        this.model.push('');
      }
    }
  }, {
    key: "addItem",
    value: function addItem() {
      if (last(this.model)) {
        this.model.push('');
        this.emitUpdateEvent();
      }
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(index) {
      if (this.model.length === 1) {
        this.model[0] = '';
      } else {
        this.model.splice(index, 1);
      }
      this.emitUpdateEvent();
    }
  }, {
    key: "update",
    value: function update(event, index) {
      var newLang = event.model;
      if (this.model[index] !== newLang) {
        this.model[index] = newLang;
        this.emitUpdateEvent();
      }
    }
  }, {
    key: "emitUpdateEvent",
    value: function emitUpdateEvent() {
      this.onChange(this.EventEmitter({
        languages: this.model
      }));
    }
  }]);
}();
module.exports = angular.module('backstage.components.common.multilanguage-picker', []).component('bsMultilanguagePicker', {
  templateUrl: '/src/angular/components/common/multilanguage-picker/multilanguage-picker.html',
  bindings: {
    model: '<',
    onChange: '&'
  },
  controller: MultilanguagePicker
}).name;